module.exports = __webpack_public_path__ + "static/img/7areaA_08.378b3a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/7areaA_08.png
// module id = 912
// module chunks = 1